import { createContext } from "react";

const PropertyFormGeneralContext = createContext();

export default PropertyFormGeneralContext;